<!-- Header Structure -->
<template>
    <div>
        <v-navigation-drawer
            v-if="!horizontal"
            app
            fixed
            v-model="drawer"
            :mini-variant="collapseSidebar"
            mini-variant-width="70"
            :width="250"
            class="Vuely-sidebar"
            :style="{backgroundImage: 'url(' + selectedSidebarBgImage.url + ')'}"
            :class="{'background-none': !backgroundImage}"
            :right="rtlLayout"
        >
            <!-- App Sidebar -->
            <app-sidebar :auth="auth" :coronerUserDto="coronerUserDto" :authProfile="authProfile"></app-sidebar>
        </v-navigation-drawer>
        <v-toolbar
            class="Vuely-toolbar"
            app
            :color="activeHeaderFilter.class"
            fixed
        >
            <div class="d-custom-flex align-items-center navbar-left">
                <div v-if="!horizontal">
                    <v-toolbar-side-icon icon large @click.stop="drawer = !drawer" class="v-step-0"></v-toolbar-side-icon>
                </div>
                <div class="site-logo-wrap d-custom-flex ml-0 align-items-center" v-else>
                    <router-link to="/" class="grayish-blue site-logo-img">
                        <img src="/static/img/wylogo.png" alt="site logo" width="100" height="30">
                    </router-link>
                </div>
                <!-- <v-text-field flat solo prepend-icon="search" :placeholder="$t('message.search')" class="search-bar "></v-text-field>
                <div class="mobile-search d-none">
                    <v-btn flat icon  small class="mobile-search-btn" >
                        <v-icon class="font-md">search</v-icon>
                    </v-btn>
                </div> -->
            </div>
            <div class="navbar-right">
                <v-btn v-if="!auth.authenticated" color="primary" @click="login">
                    Log In
                </v-btn>
                <v-btn v-else color="primary" @click="logout">
                    Log Out
                </v-btn>
                <v-btn icon large @click="toggleFullScreen" class="full-screen ma-0">
                    <v-icon color="grey">fullscreen</v-icon>
                </v-btn>
            </div>
        </v-toolbar>
    </div>
</template>

<script>
/* eslint-disable */
import Sidebar from "../Sidebar/Sidebar.vue"
//import ChatSidebar from "../ChatSidebar/ChatSidebar.vue";
import screenfull from "screenfull"
//import LanguageProvider from "./LanguageProvider";
//import Notifications from "./Notifications";
//import Cart from "./Cart";
//import QuickLinks from "./QuickLinks";
//import MobileSearchForm from "./MobileSearchForm";
import { getCurrentAppLayout } from "@/helpers/helpers"
import { mapGetters } from "vuex"

export default {
    props: {
        horizontal: {
        default: false,
        type: Boolean,
        },
        auth: {},
        coronerUserDto: {},
        authProfile: {},
        authenticated: { default: false }
    },
    data() {
        return {
            collapsed: false, // collapse sidebar
            drawer: true, // sidebar drawer default true
            chatSidebar: false, // chat component right sidebar
            sidebarImages: "", // sidebar background images
            enableDefaultSidebar: false
        };
    },
    computed: {
        ...mapGetters([
        "rtlLayout",
        "backgroundImage",
        "backgroundImage",
        "selectedSidebarBgImage",
                "darkMode",
                "collapseSidebar",
                "activeHeaderFilter"
        ])
    },
    methods: {
        // toggle full screen method
        toggleFullScreen() {
            if (screenfull.enabled) {
                screenfull.toggle();
            }
        },
        getMenuLink(link) {
            return '/' + getCurrentAppLayout(this.$router) + link;
        },
        login () {
            this.auth.login()
        },
        logout () {
            this.auth.logout()
        }
    },
    components: {
        appSidebar: Sidebar,
        //ChatSidebar,
        //LanguageProvider,
        //Notifications,
        //Cart,
        //QuickLinks,
        //MobileSearchForm
    }
};
</script>
